<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'super-admin-home' }" class="root">
                Dashboard
            </router-link>
            /
            <router-link :to="{name: 'super-master-main' }" class="root">
               Super Admin Master
            </router-link>
            <span class="child">/ Account status </span>
        </v-row>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>Account status</span>
            </v-card-title>
            <v-card-text>
                <div class="add-section">
                    <div style="text-align: center;">
                        <v-col>
                            <v-form ref="form">
                            <label class="add-text">Add New Account status</label>
                            <v-text-field class="text" v-model="accountStatus" outlined dense :rules="[rules.required]" clearable required></v-text-field>
                            <v-btn color="success" @click="addaccountStatus">Add</v-btn>
                            </v-form>
                        </v-col>
                    </div>
                </div>

                <template>
                    <div class="text-center">
                        <v-dialog v-model="dialog" width="500">
                            <v-card>
                                <v-card-title class="grey lighten-2">
                                    Edit Account status
                                </v-card-title>

                                <v-card-text style="padding-bottom: 0px;">
                                    <label class="add-text">Account status</label>
                                    <v-text-field class="text" v-model="accountStatusName" outlined dense :rules="[rules.required]" clearable required></v-text-field>
                                </v-card-text>

                                <!-- <v-divider></v-divider> -->

                                <div class="text-center">
                                    <v-spacer></v-spacer>
                                    <v-btn class="m-3" color="error" @click="dialog = false">
                                        Close
                                    </v-btn>
                                    <v-btn class="m-3" color="success" @click="saveEdit()">Update</v-btn>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>

                <template v-if="accountStatus_list!=null">
                    <v-data-table :headers="headers" :items="accountStatus_list" :search="search" class="elevation-1 nowrap">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <!-- <v-icon v-if="item.edit==true" color="success" class="mr-2">mdi-check-circle-outline</v-icon> -->
                            <v-icon v-if="item" class="mr-2" @click="updateaccountStatus(item)">mdi mdi-pencil-box</v-icon>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!-- <v-btn :loading="edit_btn_load" @click="editItem(item)" class="link" color="info"> <v-icon title="Activate/Deactivate the User Type">mdi-recycle</v-icon></v-btn> -->
                            <v-switch v-model="item.accountStatusIsactive" @change="editItem(item)"></v-switch>
                        </template>
                    </v-data-table>
                </template>
            </v-card-text>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            overlay:false,
            snackbar_msg: "",
            snackbar: false,
            color: "",
            org: null,
            dialog: false,
            search: "",
            accountStatus:null,
            accountStatusId:null,
            accountStatusName:null,
            userType: null,
            edit_btn_load: false,
            rules: {
                required: (value) => !!value || "Required.",
            },
            accountStatus_list: null,
            headers: [
                { text: "Sr no", value: "srno" },
                { text: "Name", value: "accountStatus" },
                { text: "Edit", value: "edit" },
                { text: "Toggle", value: "actions", sortable: false },
            ],
        }),
        watch: {},
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                console.log(item);
                axios
                    .post("/SuperAdmin/accountStatusIsactive", item)
                    .then(() => {
                        // this.sec_mode_list = res.data.user_list;
                        this.showSnackbar("#4CAF50", "Account status updated successfully...");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.edit_btn_load = false;
                        axios;
                    });
            },

            updateaccountStatus(item) {
                this.dialog = true;
                this.accountStatusName = item.accountStatus;
                this.accountStatusId = item.accountStatusId;
            },

            saveEdit(item) {
                console.log(item);
                if(this.accountStatusName){
                this.accountStatusName = this.accountStatusName.trim()
                }
                const data = {
                    accountStatusName: this.accountStatusName,
                    accountStatusId: this.accountStatusId,
                };
                if (this.accountStatusName) {
                    axios
                        .post("/SuperAdmin/editAccountStatus", data)
                        .then((res) => {
                            if (res.data.msg == "success") {
                            this.sec_mode_list = res.data.user_list;
                            this.showSnackbar("#4CAF50", "Account status updated successfully...");
                            this.onload();
                            this.dialog = false;
                            } else {
                                this.showSnackbar("#b71c1c", res.data.msg);
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            console.log(error);
                        })
                        .finally(() => {
                            this.edit_btn_load = false;
                            // this.editUserType = null;
                            axios;
                        });
                } else {
                    this.showSnackbar("#b71c1c", "Please enter Account status");
                }
            },

            onload() {
                this.overlay = true
                axios
                    .post("/SuperAdmin/getAccountStatus")
                    .then((res) => {
                        this.org = res.data.org;
                        this.accountStatus_list = res.data.accountStatus;
                        this.overlay = false
                        //this.showSnackbar("#4CAF50","Success")
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false
                    });
            },

            addaccountStatus() {
                if(this.accountStatus){
                this.accountStatus = this.accountStatus.trim()
                }
                const data = {
                    accountStatus_name: this.accountStatus,
                };

                if (this.accountStatus) {
                    axios
                        .post("/SuperAdmin/addAccountStatus", data)
                        .then((res) => {
                            this.org = res.data.org;
                            this.accountStatus_list = res.data.accountStatus_list;
                            if (res.data.msg == "success") {
                                this.showSnackbar("#4CAF50", "Account status added successfully...");
                                this.userType = null;
                                this.$refs.form.reset()
                            } else {
                                this.showSnackbar("#b71c1c", res.data.msg);
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            console.log(error);
                        })
                        .finally(() => {});
                } else {
                    this.showSnackbar("#b71c1c", "Please enter Account status");
                    this.$refs.form.validate()
                }
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .heading {
        background-color: #3f51b5;
        padding: 0.3rem;
        color: white;
    }
    .v-icon {
        cursor: pointer;
    }
    .text >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
</style>
